// extracted by mini-css-extract-plugin
export default {"descriptionLabel":"DemosTabContent_descriptionLabel__Foc5p"};